export const EMAIL_SUBMISSION_URL = 'https://formsubmit.co/henockb3@gmail.com';
export const ANALYTICS = 'G-DE234RM69Z';
